import { render, staticRenderFns } from "./ErrorRight.vue?vue&type=template&id=20aeaaa6&scoped=true"
import script from "./ErrorRight.vue?vue&type=script&lang=ts"
export * from "./ErrorRight.vue?vue&type=script&lang=ts"
import style0 from "./ErrorRight.vue?vue&type=style&index=0&id=20aeaaa6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aeaaa6",
  null
  
)

export default component.exports